import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  Input,
  OnChanges,
  Output,
  Provider,
  SimpleChanges
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';

export const DROPDOWN_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DropdownComponent),
  multi: true
};

@Component({
  selector: 'dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  providers: [DROPDOWN_VALUE_ACCESSOR]
})
export class DropdownComponent implements OnChanges, ControlValueAccessor {

  @Input() selected: any;
  @Input() options: Map<any, string | [string, any]>;

  @Output() select = new EventEmitter<any>();

  open = false;
  entries: [any, string | [string, any]][];

  private onChange: Function;

  constructor(private el: ElementRef,
              private Translate: TranslateService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options']) {
      this.entries = Array.from(this.options);
    }
  }

  onSelect(value: any) {
    if (this.onChange) {
      this.selected = value;
      this.onChange(value);
    }

    this.select.emit(value);
    this.open = false;
  }

  getName(prop: string | [string, any]): string {
    if (typeof prop === 'string') return prop;
    return this.Translate.instant(prop[0], prop[1]);
  }

  @HostListener('window:click', ['$event'])
  globalClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const elem = this.el.nativeElement as HTMLElement;
    if (!elem || !elem.contains) return;
    if (!elem.contains(target)) this.open = false;
  }

  writeValue(value: any): void {
    this.selected = value;
  }

  registerOnChange(fn: Function): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: Function): void {
    // Not implemented.
  }
}
